module.exports = __webpack_public_path__ + "static/img/txt.98ef061.png";


//////////////////
// WEBPACK FOOTER
// ./static/ugc/creation/txt.png
// module id = 6wSN
// module chunks = 1